import { PaymentCondition } from '../../lib/types/models/payment-condition/payment-condition'
import { PaymentConditionInput } from '../../lib/types/models/payment-condition/payment-condition-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createPaymentCondition(data: PaymentConditionInput) {
  return restApiClient
    .url(constructApiUrl(API.paymentConditions.create.url, null))
    .post<PaymentCondition, PaymentConditionInput>(data)
}
